import {
  Address,
  ChainKey,
  makeAddressRecordSync,
  makeAddressSync,
} from "@silo/types";
import { satisfies } from "effect/Function";

export const TOKEN_ADDRESS = satisfies<
  Record<ChainKey, Record<string, Address>>
>()({
  ethereum: makeAddressRecordSync({
    USDC: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
    WETH: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
    APE: "0x4d224452801ACEd8B2F0aebE155379bb5D594381",
    BAL: "0xba100000625a3754423978a60c9317c58a424e3D",
    CRV: "0xD533a949740bb3306d119CC777fa900bA034cd52",
    CVX: "0x4e3FBD56CD56c3e72c1403e103b45Db9da5B9D2B",
    FRAX: "0x853d955aCEf822Db058eb8505911ED77F175b99e",
    FXS: "0x3432B6A60D23Ca0dFCa7761B7ab56459D9C964D0",
    WBTC: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
    wstETH: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
    cbETH: "0xBe9895146f7AF43049ca1c1AE358B0541Ea49704",
    LINK: "0x514910771AF9Ca656af840dff83E8264EcF986CA",
    XAI: "0xd7C9F0e536dC865Ae858b0C0453Fe76D13c3bEAc",
    BADGER: "0x3472A5A71965499acd81997a54BBA8D852C6E53d",
    AURA: "0xC0c293ce456fF0ED870ADd98a0828Dd4d2903DBF",
    SUSHI: "0x6B3595068778DD592e39A122f4f5a5cF09C90fE2",
    xSUSHI: "0x8798249c2E607446EfB7Ad49eC89dD1865Ff4272",
    USDT: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
    ENJ: "0xF629cBd94d3791C9250152BD8dfBDF380E2a3B9c",
    PAXG: "0x45804880De22913dAFE09f4980848ECE6EcbAf78",
    MIM: "0x99D8a9C45b2ecA8864373A26D1459e3Dff1e17F3",
    OHM: "0x64aa3364F17a4D01c6f1751Fd97C2BD3D7e7f1D5",
    WOO: "0x4691937a7508860F876c9c0a2a617E7d9E945D4B",
    ZRX: "0xE41d2489571d322189246DaFA5ebDe1F4699F498",
    SHIB: "0x95aD61b0a150d79219dCF64E1E6Cc01f0B64C4cE",
    GUSD: "0x056Fd409E1d7A124BD7017459dFEa2F387b6d5Cd",
    USDP: "0x8E870D67F660D95d5be530380D0eC0bd388289E1",
    CRO: "0xA0b73E1Ff0B80914AB6fe0444E65848C4C34450b",
    COMP: "0xc00e94Cb662C3520282E6f5717214004A7f26888",
    MANA: "0x0F5D2fB29fb7d3CFeE444a200298f468908cC942",
    gOHM: "0x0ab87046fBb341D058F17CBC4c1133F25a20a52f",
    GNO: "0x6810e776880C02933D47DB1b9fc05908e5386b96",
    LUSD: "0x5f98805A4E8be255a32880FDeC7F6728C6568bA0",
    ENS: "0xC18360217D8F7Ab5e7c516566761Ea12Ce7F9D72",
    IMX: "0xF57e7e7C23978C3cAEC3C3548E3D615c346e79fF",
    BUSD: "0x4Fabb145d64652a948d72533023f6E7A623C7C53",
    ONEINCH: "0x111111111117dC0aa78b770fA6A738034120C302",
    QNT: "0x4a220E6096B25EADb88358cb44068A3248254675",
    TUSD: "0x0000000000085d4780B73119b644AE5ecd22b376",
    YFI: "0x0bc529c00C6401aEF6D220BE8C6Ea1667F6Ad93e",
    BAT: "0x0D8775F648430679A709E98d2b0Cb6250d2887EF",
    UMA: "0x04Fa0d235C4abf4BcF4787aF4CF447DE572eF828",
    sUSD: "0x57Ab1ec28D129707052df4dF418D58a2D46d5f51",
    JPEG: "0xE80C0cd204D654CEbe8dd64A4857cAb6Be8345a3",
    BNT: "0x1F573D6Fb3F13d689FF844B4cE37794d79a7FF1C",
    LDO: "0x5A98FcBEA516Cf06857215779Fd812CA3beF1B32",
    USDD: "0x0C10bF8FcB7Bf5412187A595ab97a3609160b5c6",
    SETH2: "0xFe2e637202056d30016725477c5da089Ab0A043A",
    NFTX: "0x87d73E916D7057945c9BcD8cdd94e42A6F47f776",
    DAI: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
    BIT: "0x1A4b46696b2bB4794Eb3D4c26f1c55F9170fa4C5",
    SPELL: "0x090185f2135308BaD17527004364eBcC2D37e5F6",
    FARM: "0xa0246c9032bC3A600820415aE600c6388619A14D",
    RPL: "0xD33526068D116cE69F19A9ee46F0bd304F21A51f",
    LQTY: "0x6DEA81C8171D0bA574754EF6F8b412F2Ed88c54D",
    OCEAN: "0x967da4048cD07aB37855c090aAF366e4ce1b9F48",
    ALCX: "0xdBdb4d16EdA451D0503b854CF79D55697F90c8DF",
    DYDX: "0x92D6C1e31e14520e676a687F0a93788B716BEff5",
    SAND: "0x3845badAde8e6dFF049820680d1F14bD3903a5d0",
    SNX: "0xC011a73ee8576Fb46F5E1c5751cA3B9Fe0af2a6F",
    UNI: "0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984",
    AAVE: "0x7Fc66500c84A76Ad7e9c93437bFc5Ac33E2DDaE9",
    RAI: "0x03ab458634910AaD20eF5f1C8ee96F1D6ac54919",
    KP3R: "0x1cEB5cB57C4D4E2b2433641b95Dd330A33185A44",
    FUN: "0x419D0d8BdD9aF5e606Ae2232ed285Aff190E711b",
    FTT: "0x50D1c9771902476076eCFc8B2A83Ad6b9355a4c9",
    PERP: "0xbC396689893D065F41bc2C6EcbeE5e0085233447",
    WNXM: "0x0d438F3b5175Bebc262bF23753C1E53d03432bDE",
    MKR: "0x9f8F72aA9304c8B593d555F12eF6589cC3A579A2",
    LOOKS: "0xf4d2888d29D722226FafA5d9B24F9164c092421E",
    AGEUR: "0x1a7e4e63778B4f12a199C062f3eFdD288afCBce8",
    RETH: "0xae78736Cd615f374D3085123A210448E74Fc6393",
    PEPE: "0x6982508145454Ce325dDbE47a25d4ec3d2311933",
    XDEFI: "0x72B886d09C117654aB7dA13A14d603001dE0B777",
    BOX_ETH: "0x7690202e2C2297bcD03664e31116d1dFfE7e3B73",
    ETH_stETH: "0x041dFD7E8497B3b47b2260Fc0CeD9443c67C9Ed2",
    FRAX_USDC: "0xfCDeEe2BfEAe88E749E88a628E2C3401Ec5edA3C",
    ETH_cbETH: "0x3D077847c98e3f370D3355e4ed3aEDd4E92cFE53",
    LUSD_3CRV: "0xA600dF1FB4c79a668c4d9E3016504d28BFaAfF1a",
    stETH_NG: "0x470f9f350642eDF3CB3f2a6eB4569c0219386F0b",
    crvUSD: "0xf939E0A03FB07F59A73314E73794Be0E57ac1b4E",
    SILO: "0x6f80310CA7F2C654691D1383149Fa1A57d8AB1f8",
    UWU: "0x55C08ca52497e2f1534B59E2917BF524D4765257",
    weETH: "0xCd5fE23C85820F7B72D0926FC9b05b43E359b7ee",
    ETHx: "0xA35b1B31Ce002FBF2058D22F30f95D405200A15b",
    PTezETH: "0xeEE8aED1957ca1545a0508AfB51b53cCA7e3c0d1",
    sUSDe: "0x9D39A5DE30e57443BfF2A8307A4256c8797A3497",
    ezETH: "0xbf5495Efe5DB9ce00f80364C8B423567e58d2110",
    PTrswETH: "0x5cb12D56F5346a016DBBA8CA90635d82e6D1bcEa",
    rsETH: "0xA1290d69c65A6Fe4DF752f95823fae25cB99e5A7",
    PTrsETH: "0xB05cABCd99cf9a73b19805edefC5f67CA5d1895E",
    PTweETH: "0xc69Ad9baB1dEE23F4605a82b3354F8E40d1E5966",
    PTezETH_DEC2024: "0xf7906F274c174A52d444175729E3fa98f9bde285",
    PT_ezETH_26SEP2024: "0x248241244356D18f63d0c16082996839ecB0C7bF",
    PT_weETH_26SEP2024: "0x1c085195437738d73d75DC64bC5A3E098b7f93b1",
    PT_sUSDE_26SEP2024: "0x6c9f097e044506712B58EAC670c9a5fd4BCceF13",
    PT_pufETH_26SEP2024: "0xd4e75971eAF78a8d93D96df530f1FFf5f9F53288",
    pzETH: "0x8c9532a60e0e7c6bbd2b2c1303f63ace1c3e9811",
    amphrETH: "0x5fD13359Ba15A84B76f7F87568309040176167cd",
    rstETH: "0x7a4EffD87C2f3C55CA251080b1343b605f327E3a",
    re7LRT: "0x84631c0d0081fde56deb72f6de77abbbf6a9f93a",
    PTweETH_DEC2024: "0x6ee2b5E19ECBa773a352E5B21415Dc419A700d1d",
    PTrsETH_DEC2024: "0xB07b9fDd62DC478E521E8bDe3630a777725B0eB4",
    PTpufETH_DEC2024: "0xF6fd7Ceb095BfD54130359Cc9366a1493944213A",
  }),
  arbitrum: makeAddressRecordSync({
    GMD: "0x4945970EfeEc98D393b4b979b9bE265A3aE28A8B",
    USDs: "0xD74f5255D557944cf7Dd0E45FF521520002D5748",
    DAI: "0xDA10009cBd5D07dd0CeCc66161FC93D7c9000da1",
    GMX: "0xfc5A1A6EB076a2C7aD06eD22C90d7E710E35ad0a",
    CRV: "0x11cDb42B0EB46D95f990BeDD4695A6e3fA034978",
    UMAMI: "0x1622bF67e6e5747b81866fE0b85178a93C7F86e3",
    LINK: "0xf97f4df75117a78c1A5a0DBb814Af92458539FB4",
    DPX: "0x6C2C06790b3E3E3c38e12Ee22F8183b37a13EE55",
    WBTC: "0x2f2a2543B76A4166549F7aaB2e75Bef0aefC5B0f",
    MAGIC: "0x539bdE0d7Dbd336b79148AA742883198BBF60342",
    USDT: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
    CAP: "0x031d35296154279DC1984dCD93E392b1f946737b",
    UNI: "0xFa7F8980b0f1E64A2062791cc3b0871572f1F7f0",
    USDC_e: "0xFF970A61A04b1cA14834A43f5dE4533eBDDB5CC8",
    WETH: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
    rDPX: "0x32Eb7902D4134bf98A28b963D26de779AF92A212",
    GNS: "0x18c11FD286C5EC11c3b683Caa813B77f5163A122",
    ARB: "0x912CE59144191C1204E64559FE8253a0e49E6548",
    PREMIA: "0x51fC0f6660482Ea73330E414eFd7808811a57Fa2",
    JONES: "0x10393c20975cF177a3513071bC110f7962CD67da",
    OHM: "0xf0cb2dc0db5e6c66B9a70Ac27B06b878da017028",
    wstETH: "0x5979D7b546E38E414F7E9822514be443A4800529",
    SILO: "0x0341C0C0ec423328621788d4854119B97f44E391",
    rETH: "0xEC70Dcb4A1EFa46b8F2D97C310C9c4790ba5ffA8",
    Y2K: "0x65c936f008BC34fE819bce9Fa5afD9dc2d49977f",
    JOE: "0x371c7ec6d8039ff7933a2aa28eb827ffe1f52f07",
    PLS: "0x51318B7D00db7ACc4026C88c3952B66278B6A67F",
    GRAIL: "0x3d9907F9a368ad0a51Be60f7Da3b97cf940982D8",
    PENDLE: "0x0c880f6761f1af8d9aa9c466984b80dab9a8c9e8",
    RDNT: "0x3082CC23568eA640225c2467653dB90e9250AaA0",
    WOO: "0xcAFcD85D8ca7Ad1e1C6F82F651fA15E33AEfD07b",
    WINR: "0xD77B108d4f6cefaa0Cae9506A934e825BEccA46E",
    stEUR: "0x004626A008B1aCdC4c74ab51644093b155e59A23",
    LUSD: "0x93b346b6BC2548dA6A1E7d98E9a421B42541425b",
    weETH: "0x35751007a407ca6FEFfE80b3cB397736D2cf4dbe",
    PTeETH: "0x9bEcd6b4Fb076348A455518aea23d3799361FE95",
    tBTC: "0x6c84a8f1c29108F47a79964b5Fe888D4f4D0dE40",
    GRAI: "0x894134a25a5faC1c2C26F1d8fBf05111a3CB9487",
    PTezETH: "0x8EA5040d423410f1fdc363379Af88e1DB5eA1C34",
    ezETH: "0x2416092f143378750bb29b79eD961ab195CcEea5",
    PTweETH: "0x1c27Ad8a19Ba026ADaBD615F6Bc77158130cfBE4",
    PTrsETH: "0xAFD22F824D51Fb7EeD4778d303d4388AC644b026",
    WOETH: "0xD8724322f44E5c58D7A815F542036fb17DbbF839",
    PTUSDe: "0xad853EB4fB3Fe4a66CdFCD7b75922a0494955292",
    PTezETH_SEPT2024: "0x2CCFce9bE49465CC6f947b5F6aC9383673733Da9",
    PTweETH_SEPT2024: "0xb8b0a120F6A68Dd06209619F62429fB1a8e92feC",
    PTrsETH_SEPT2024: "0x30c98c0139B62290E26aC2a2158AC341Dcaf1333",
    uniETH: "0x3d15fD46CE9e551498328B1C83071D9509E2C3a0",
    ETHplus: "0x18C14C2D707b2212e17d1579789Fc06010cfca23",
    PEAS: "0x02f92800F57BCD74066F5709F1Daa1A4302Df875",
    RAM: "0xAAA6C1E32C55A7Bfa8066A6FAE9b42650F262418",
    wUSDplus: "0xB86fb1047A955C0186c77ff6263819b37B32440D",
    gUSDC: "0xd3443ee1e91aF28e5FB858Fbd0D72A63bA8046E0",
    ptUSDE_NOV2024: "0x1FA42e6730DF74fF2742704761Da41111bB7F019",
    dlcBTC: "0x050C24dBf1eEc17babE5fc585F06116A259CC77A",
    wUSDM: "0x57F5E098CaD7A3D1Eed53991D4d66C45C9AF7812",
    PTweETH_DEC2024: "0xe2b2d203577c7cb3d043e89ccf90b5e24d19b66f",
    PTrsETH_DEC2024: "0x355ec27c9d4530dE01A103FA27F884a2F3dA65ef",
    ORDER: "0x4E200fE2f3eFb977d5fd9c430A41531FB04d97B8",
    PTweETH_JUN2025: "0xb33808ea0e883138680BA29311a220A7377cdb92",
    PTrsETH_JUN2025: "0x8Db96f2FcCf7Cdd74a60e8eFf5801df043cd11dE",
    gmETH: "0x70d95587d40A2caf56bd97485aB3Eec10Bee6336",
    TANGO: "0xC760F9782F8ceA5B06D862574464729537159966",
  }),
  optimism: makeAddressRecordSync({
    USDC: "0x0b2C639c533813f4Aa9D7837CAf62653d097Ff85",
    WETH: "0x4200000000000000000000000000000000000006",
    OP: "0x4200000000000000000000000000000000000042",
    SNX: "0x8700dAec35aF8Ff88c16BdF0418774CB3D7599B4",
    PENDLE: "0xBC7B1Ff1c6989f006a1185318eD4E7b5796e66E1",
    VELO: "0x3c8B650257cFb5f272f799F5e2b4e65093a11a05",
    VELO_V2: "0x9560e827aF36c94D2Ac33a39bCE1Fe78631088Db",
    DAI: "0xDA10009cBd5D07dd0CeCc66161FC93D7c9000da1",
    rETH: "0x9Bcef72be871e61ED4fBbc7630889beE758eb81D",
    sUSD: "0x8c6f28f2F1A3C87F0f938b96d27520d9751ec8d9",
    WLD: "0xdC6fF44d5d932Cbd77B52E5612Ba0529DC6226F1",
    tBTC: "0x6c84a8f1c29108F47a79964b5Fe888D4f4D0dE40",
    PERP: "0x9e1028F5F1D5eDE59748FFceE5532509976840E0",
    USDT: "0x94b008aA00579c1307B0EF2c499aD98a8ce58e58",
    sfrxETH: "0x484c2D6e3cDd945a8B2DF735e079178C1036578c",
    wstETH: "0x1F32b1c2345538c0c6f582fCB022739c4A194Ebb",
    WBTC: "0x68f180fcCe6836688e9084f035309E29Bf0A2095",
    ezETH: "0x2416092f143378750bb29b79eD961ab195CcEea5",
    uniBTC: "0x93919784C523f39CACaa98Ee0a9d96c3F32b593e",
    wUSDM: "0x57F5E098CaD7A3D1Eed53991D4d66C45C9AF7812",
    SILO: "0xa6521C950B0aB5215337Dab84d65F4fFa7F6dF55",
    mooBIFI: "0xc55E93C62874D8100dBd2DfE307EDc1036ad5434",
  }),
  base: makeAddressRecordSync({
    WETH: "0x4200000000000000000000000000000000000006",
    cbETH: "0x2Ae3F1Ec7F1F5012CFEab0185bfc7aa3cf0DEc22",
    wstETH: "0xc1CBa3fCea344f92D9239c08C0568f6F2F0ee452",
    DEGEN: "0x4ed4E862860beD51a9570b96d89aF5E1B0Efefed",
    ezETH: "0x2416092f143378750bb29b79eD961ab195CcEea5",
    AERO: "0x940181a94A35A4569E4529A3CDfB74e38FD98631",
    bsdETH: "0xCb327b99fF831bF8223cCEd12B1338FF3aA322Ff",
    weETH: "0x04C0599Ae5A44757c0af6F9eC3b93da8976c150A",
    tBTC: "0x236aa50979D5f3De3Bd1Eeb40E81137F22ab794b",
    SILO: "0xF734eFdE0C424BA2B547b186586dE417b0954802",
    cbBTC: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
    wUSDM: "0x57F5E098CaD7A3D1Eed53991D4d66C45C9AF7812",
    wUSDPlus: "0xd95ca61CE9aAF2143E81Ef5462C0c2325172E028",
    sUSDz: "0xe31eE12bDFDD0573D634124611e85338e2cBF0cF",
    EURC: "0x60a3E35Cc302bFA44Cb288Bc5a4F316Fdb1adb42",
    wSuperOETHb: "0x7FcD174E80f264448ebeE8c88a7C4476AAF58Ea6",
    hyUSD: "0xCc7FF230365bD730eE4B352cC2492CEdAC49383e",
    pumpBTC: "0xF469fBD2abcd6B9de8E169d128226C0Fc90a012e",
    solvBTC: "0x3B86Ad95859b6AB773f55f8d94B4b9d443EE931f",
    solvBTCBNN: "0xC26C9099BD3789107888c35bb41178079B282561",
    LBTC: "0xecAc9C5F704e954931349Da37F60E39f515c11c1",
    PT_LBTC_MAY_2025: "0x5d746848005507DA0b1717C137A10C30AD9ee307",
    USDC: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
  }),
  local: makeAddressRecordSync({}),
  anvil: makeAddressRecordSync({}),
} as const);

export const SILO_V1_TOKEN_ADDRESSES = new Set([
  TOKEN_ADDRESS.ethereum.SILO,
  TOKEN_ADDRESS.arbitrum.SILO,
  TOKEN_ADDRESS.base.SILO,
  TOKEN_ADDRESS.optimism.SILO,
]);

/**
 * Need to manually set emission per second to 0 for this share token since
 * there is a contract bug.
 */
export const ARB_WBTC_S_TOKEN_ADDRESS = makeAddressSync(
  "0x29Aa259659402c6280620048e976537ff9AFFdbB"
);
